"use client";

import React, { useEffect, useRef, useState } from "react";


import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import '../app/homepage.css';
import Image from "next/image";
import img3 from "@/public/images/mobile-img/digital-cart/mob-digital-cart.webp";

import StatsSection from "./StatusSection";
import GlobalPartnersCount from "@/components/GlobalPartnersCount";
import { m, Variants } from "framer-motion"; // Import framer-motion
import { useInView } from "react-intersection-observer"; // Import react-intersection-observer

import FaqSection from "./Homepagefaq";
import { digitalCartFaqItems } from "@/app/digital-cart/faq";
import { CheckCircle2, Link2, Share2, Smartphone, Users, Briefcase, BadgeCheck, Check } from "lucide-react";
import TestiReviewCommonImages from "./otherpages/TestiReviewCommonImages";
import { ReviewStar as Icon_ReviewStar } from "@/components/customer/icons/ReviewStar";
import { TickSvg as Icon_TickSvg } from "@/components/customer/icons/TickSvg";
const SvgIcons = { ReviewStar: Icon_ReviewStar, TickSvg: Icon_TickSvg };
import { getImageUrl } from "@/lib/imageUrl";
import phonepe from "@/public/images/mobile-img/swiper-logo/phonepe.webp"
import instamojo from "@/public/images/mobile-img/swiper-logo/instamojo.webp"
import digitalocean from "@/public/images/mobile-img/swiper-logo/digitalocean.webp"
import cloudflare from "@/public/images/mobile-img/swiper-logo/cloudflare.webp"
import nimbuspost from "@/public/images/mobile-img/swiper-logo/nimbuspost.webp"
import aws from "@/public/images/mobile-img/swiper-logo/aws.webp"
import shiprocket from "@/public/images/mobile-img/swiper-logo/shiprocket-logo-512.webp"
import TrustedPartners from "./TrustedPartners";
const DigitalCart = () => {


  
    // Animation variants for fade-in effect
    const fadeIn: Variants = {
        hidden: { opacity: 0, y: 20 },
        visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } }
    };
    const [whatIsRef, whatIsInView] = useInView({ triggerOnce: true, threshold: 0.2 });
  
   
    // ADD THESE - Put with your other useInView hooks
    const [pricingSectionRef, pricingSectionInView] = useInView({ triggerOnce: true, threshold: 0.2 });
    const [comparisonRef, comparisonInView] = useInView({ triggerOnce: true, threshold: 0.2 });
    const [teamRef, teamInView] = useInView({ triggerOnce: true, threshold: 0.2 });


    const [heroRef, heroInView] = useInView({
        threshold: 0.1,  // Lower threshold
        triggerOnce: false  // Allow re-trigger
    });
    const [featuresRef, featuresInView] = useInView({ threshold: 0.1, triggerOnce: false });
    const [pricingRef, pricingInView] = useInView({ threshold: 0.1, triggerOnce: false });
    


    type CardItem = {
        title: string;
        desc: string;
        img: any;
    };
    type Feature = {
        title: string;
        desc: string;
        img: string;
    };
    const rightCards: CardItem[] = [
        {
            title: "Small Business Owners",
            desc: "Create a professional online presence without building or managing a full website.",
            img: undefined
        },
        {
            title: "Freelancers & Service Providers",
            desc: "Showcase what you offer clearly and let customers contact you instantly.",
            img: undefined
        },
        {
            title: "Sales & Working Professionals",
            desc: "Replace traditional visiting cards with a smarter, always-updated digital alternative.",
            img: undefined
        },
    ]

    function InfoCard({ title, desc }: CardItem) {
        return (
            <div className="rounded-[4px] border-b-2 border-[#195AFF] bg-white px-[24px] py-[16px] shadow-[0_8px_24px_rgba(2,38,129,0.10)]">
                <div className="flex gap-3">
                    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
                        <path d="M11 0.4493C11 0.19617 10.7942 -0.0100205 10.5413 0.000404626C4.68758 0.241693 0 5.07904 0 10.991C0 17.0566 4.93442 21.991 11 21.991C16.9119 21.991 21.7493 17.3034 21.9906 11.4497C22.001 11.1968 21.7948 10.991 21.5417 10.991H19.9833C19.7302 10.991 19.5263 11.1965 19.5128 11.4492C19.2739 15.9377 15.5469 19.516 11 19.516C6.29933 19.516 2.475 15.6916 2.475 10.991C2.475 6.44403 6.05329 2.71704 10.5417 2.47813C10.7945 2.46468 11 2.26076 11 2.00763V0.4493ZM18.1411 2.64511C17.9435 2.48693 17.6551 2.51884 17.4969 2.7164L10.9038 10.9488L8.04301 8.60441C7.84741 8.44412 7.55896 8.47253 7.3984 8.6679L6.14515 10.1928C5.98431 10.3885 6.01273 10.6776 6.20861 10.8382L10.1997 14.1113C10.3474 14.2331 10.5178 14.3243 10.701 14.3795C10.8843 14.4348 11.0767 14.453 11.2671 14.4331C11.4574 14.4132 11.6419 14.3556 11.8098 14.2637C11.9776 14.1718 12.1255 14.0474 12.2448 13.8977L19.7536 4.52328C19.9118 4.32568 19.8799 4.03718 19.6823 3.87895L18.1411 2.64511Z" fill="#195AFF" />
                    </svg>
                    <div>
                        <p className="font-Schibsted_Grotesk text-[16px] font-semibold text-[#0B1535]">
                            {title}
                        </p>
                        <p className="font-Schibsted_Grotesk text-[13px] leading-[1.6] text-[#6B7280]">
                            {desc}
                        </p>
                    </div>
                </div>

            </div>
        );
    }
    function CenterRing() {
        return (
            <div className="relative mx-auto flex w-full max-w-[320px] items-center justify-center">
                {/* dotted circle */}
                <div className="absolute h-[260px] w-[260px] rounded-full border-2 border-dashed border-[#7AA5FF] opacity-70" />

                {/* center logo circle */}
                <div className="relative z-10 flex h-[96px] w-[96px] items-center justify-center rounded-full bg-[#1F5DFF] shadow-[0_18px_50px_rgba(31,93,255,0.35)]">
                    <span className="font-NeueMontreal text-[44px] font-black text-white">
                        {/* <Image
                            src={img5}
                            alt="image tag"
                        /> */}
                        <Image
                            src={getImageUrl("/vilvabusiness/website/products/digitalcart/Vilva%20(1).webp")}
                            alt="Vilva Digital Cart — digital catalogue & ordering"
                            fill
                            priority
                            decoding="async"
                        />
                    </span>
                </div>

                {/* orbit icons */}
                <div className="absolute h-[320px] w-[320px]">
                    <OrbitIcon className="left-1/2 top-1 -translate-x-1/2" icon={<Link2 className="h-6 w-6 text-[#1F5DFF]" />} />
                    <OrbitIcon className="right-2 top-1/2 -translate-y-1/2" icon={<Briefcase className="h-6 w-6 text-[#1F5DFF]" />} />
                    <OrbitIcon className="left-[20%] bottom-1 -translate-x-1/2" icon={<Smartphone className="h-6 w-6 text-[#1F5DFF]" />} />
                    <OrbitIcon className="left-2 top-1/2 -translate-y-1/2" icon={<Share2 className="h-6 w-6 text-[#1F5DFF]" />} />
                    <OrbitIcon className="left-[10%] top-[14%]" icon={<BadgeCheck className="h-6 w-6 text-[#1F5DFF]" />} />
                    <OrbitIcon className="right-[20%] bottom-[-1%]" icon={<Users className="h-6 w-6 text-[#1F5DFF]" />} />
                </div>
            </div>
        );
    }
    function OrbitIcon({
        className,
        icon,
    }: {
        className: string;
        icon: React.ReactNode;
    }) {
        return (
            <div
                className={[
                    "absolute flex h-[62px] w-[62px] items-center justify-center rounded-[14px]",
                    "bg-[#EAF1FF] shadow-[0_10px_24px_rgba(15,23,42,0.12)] ring-1 ring-black/5",
                    className,
                ].join(" ")}
            >
                {icon}
            </div>
        );
    }
    const features: Feature[] = [
        {
            title: "Business Profile & Info",
            desc: "Complete business details, location, hours, and contact information in one place.",
            img: `${getImageUrl("/vilvabusiness/website/products/digitalcart/digital-1.png")}`,
        },
        {
            title: "Products & Services Listing",
            desc: "Showcase your offerings with images, descriptions, and pricing.",
            img: `${getImageUrl("/vilvabusiness/website/products/digitalcart/digital-2.png")}`,
        },
        {
            title: "Click-to-Call & WhatsApp",
            desc: "Instant communication with one-tap calling and WhatsApp messaging.",
            img: `${getImageUrl("/vilvabusiness/website/products/digitalcart/digital-3.png")}`,
        },
        {
            title: "QR Code Sharing",
            desc: "Generate QR codes for easy sharing at events, meetings, or print materials.",
            img: `${getImageUrl("/vilvabusiness/website/products/digitalcart/digital-4.png")}`,
        },
        {
            title: "NFC Card Integration",
            desc: "Modern NFC-enabled business cards that work with a simple tap.",
            img: `${getImageUrl("/vilvabusiness/website/products/digitalcart/digital-5.png")}`,
        },
        {
            title: "Lead Collection Form",
            desc: "Capture customer inquiries and contact details automatically.",
            img: `${getImageUrl("/vilvabusiness/website/products/digitalcart/digital-6.png")}`,
        },
    ];
    const steps = [
        {
            title: "Create once",
            desc: "Set up your Digital Cart with business details and services.",
        },
        {
            title: "Share anywhere",
            desc: "Use link, QR, or NFC during meetings, events, or online.",
        },
        {
            title: "Stay reachable",
            desc: "Customers contact you instantly without friction.",
        },
    ];
    const included = [
        "Web and mobile access",
        "Business profile setup",
        "Products and services listing",
        "QR code for easy sharing",
        "NFC-ready support",
        "Contact and lead collection form",
        "Basic customer support",
    ];

    const rows = [
        { label: "Editable anytime", digital: true, paper: "No" },
        { label: "Share instantly", digital: true, paper: "No" },
        { label: "Works online", digital: true, paper: "No" },
        { label: "NFC enabled", digital: true, paper: "No" },
        { label: "Professional & modern", digital: true, paper: "Limited" },
    ];
    const partners = [
        { href: "https://business.phonepe.com/register?referral-code=RF2405271212318567147728", src: phonepe, alt: "PhonePe Logo" },
        { href: "https://www.instamojo.com/", src: instamojo, alt: "Instamojo Logo" },
        { href: "https://www.digitalocean.com/", src: digitalocean, alt: "DigitalOcean Logo" },
        { href: "https://www.cloudflare.com/", src: cloudflare, alt: "Cloudflare Logo" },
        { href: "https://app.shiprocket.in/register", src: shiprocket, alt: "Shiprocket Logo" },
        { href: "https://ship.nimbuspost.com/", src: nimbuspost, alt: "Nimbuspost Logo" },
        { href: "https://aws.amazon.com/free/", src: aws, alt: "Amazon Web Services Logo" },
    ];

    return (
        <div className="">
            {/* Hero Section */}
            <m.section
                ref={heroRef}
                initial="hidden"
                animate={heroInView ? "visible" : "hidden"}
                variants={fadeIn}
                className="bg-opacity-30 mt-[20px] lg:mt-18"
            >
                <section className="relative overflow-hidden bg-[#F6FAFF] relative sm:min-h-[100vh] min-h-[70vh] bg-cover bg-center bg-no-repeat text-white overflow-hidden">
                    {/* subtle grid background */}
                    <div className="pointer-events-none absolute inset-0 opacity-[0.55]">
                        {/* Desktop Background */}
                        <Image
                            src={getImageUrl("/vilvabusiness/website/products/digitalcart/Background.webp")}
                            alt="Digital Cart background"
                            fill
                            className="hidden md:block object-cover z-0"
                            loading="lazy"
                            decoding="async"
                            sizes="100vw"
                        />

                        {/* Mobile Background */}
                        <Image
                            src={getImageUrl("/vilvabusiness/website/products/digitalcart/Background.webp")}
                            alt="Digital Cart background mobile"
                            fill
                            className="block md:hidden object-cover z-0"
                            loading="lazy"
                            decoding="async"
                            sizes="100vw"
                        />

                    </div>

                    <div className="relative mx-auto max-w-6xl px-4 sm:px-6 lg:px-8 md:mt-[48px] mt-[40px]">
                        {/* pill */}
                        <div className="flex justify-center">
                            <span className="inline-flex items-center rounded-[26px] border-2 border-[#E9FDE7] bg-white px-4 py-2 text-[14px] sm:text-[13px] font-medium text-[#33C120] shadow-sm font-Schibsted_Grotesk">
                                Share via Link • QR • NFC
                            </span>
                        </div>

                        {/* heading */}
                        <div className="mt-6 text-center">
                            <h1 className="mx-auto max-w-4xl font-NeueMontreal text-[36px] sm:text-[48px] lg:text-[64px] font-extrabold leading-[1.05] text-[#0B1535]">
                                Your{" "}
                                <span className="text-[#1344C3] font-NeueMontreal">Digital Business Card</span>
                                <br />
                                But Actually Useful
                            </h1>

                            <p className="mx-auto mt-[16px] max-w-3xl font-Schibsted_Grotesk text-[14px] sm:text-[16px] lg:text-[18px] leading-[1.6] text-[#4E5B7D]">
                                A single digital page to showcase your business, products, services,
                                and contact details. Works on web and mobile, Share it using a link,
                                QR code, or NFC card.
                            </p>

                            {/* buttons */}
                            <div className="mt-8 flex flex-wrap items-center justify-center gap-[24px]">
                                <a
                                    href="/book-demo"
                                    className="font-Schibsted_Grotesk rounded-[10px] border-2 border-[#195AFF] bg-white  py-[16px] px-[32px] text-[14px] sm:text-[15px] font-[500] text-[#1F5DFF] flex items-center justify-center shadow-sm hover:bg-[#F1F6FF] transition"
                                >
                                    Free Demo
                                </a>

                                <a target="_blank"
                                    href="https://api.whatsapp.com/send?phone=919176569459&text=Hi%20Vilva%20Team%2C%20I%20would%20like%20to%20know%20more%20about%20the%20Digital%20Cart%20solution.%20Please%20share%20the%20details.%0A%0AThank%20you!"
                                    className="font-Schibsted_Grotesk rounded-[8px] bg-[#1F5DFF] py-[16px] px-[32px] text-[14px] sm:text-[15px] font-[500] text-white flex items-center justify-center shadow-[0_12px_30px_rgba(31,93,255,0.25)] hover:opacity-95 transition"
                                >
                                    Get Digital Cart
                                </a>
                            </div>
                        </div>

                        {/* mockups */}
                        <div className="mt-12 sm:mt-14 lg:mt-16 flex justify-center">
                            <div className="relative w-full max-w-5xl">
                                <div className="relative mx-auto w-[92%] sm:w-[82%] lg:w-[72%]">
                                    <div className="relative aspect-[16/9] overflow-hidden">

                                        {/* Desktop Image */}
                                        <Image
                                            src={getImageUrl("/vilvabusiness/website/products/digitalcart/Image%20Mockup.svg")}
                                            alt="Digital Cart dashboard"
                                            fill
                                            className=" object-contain"
                                            loading="lazy"
                                            decoding="async"
                                            sizes="(min-width: 768px) 800px"
                                        />


                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </m.section>

            <TrustedPartners className="relative md:py-[40px] py-[20px]" />

            {/* What Is Digital Cart? */}
            <m.section
                ref={whatIsRef}
                initial="hidden"
                animate={whatIsInView ? "visible" : "hidden"}
                variants={fadeIn}
                className=""
            >
                <section className="relative bg-[#F6FAFF] md:py-[120px] py-[60px]">
                    {/* subtle grid bg */}
                    <div className="pointer-events-none absolute inset-0 opacity-[0.5]">
                    </div>

                    <div className="relative mx-auto max-w-6xl px-[15px]">
                        {/* Title */}
                        <div className="text-center">
                            <h2 className="font-NeueMontreal text-[30px] sm:text-[38px] lg:text-[44px] font-extrabold leading-[1.15] text-[#0B1535]">
                                What Is <span className="text-[#1F5DFF] font-NeueMontreal">Digital Cart?</span>
                            </h2>

                            <p className="mx-auto mt-3 max-w-3xl font-Schibsted_Grotesk text-[13px] sm:text-[15px] leading-[1.7] text-[#667085]">
                                Digital Cart is a simple digital page that represents your business online.
                                It brings all your business details, services, products, and contact options
                                into one easy-to-share link.
                            </p>
                        </div>

                        {/* Desktop layout */}
                        <div className="mt-10 hidden lg:grid grid-cols-[1fr_360px_1fr] gap-10 items-center">
                            {/* left cards */}
                            <div className="space-y-6">
                                {[
                                    {
                                        title: "One Digital Business Page",
                                        desc: "All your business details, services, products, and contact options in one single digital page.",
                                    },
                                    {
                                        title: "Easy to Share Anywhere",
                                        desc: "Share your Digital Cart instantly using a link, QR code, or NFC card.",
                                    },
                                    {
                                        title: "Works on Any Device",
                                        desc: "Opens smoothly on mobile, tablet, and desktop without requiring any app.",
                                    },
                                ].map((c) => (
                                    <InfoCard key={c.title} title={c.title} desc={c.desc} img={undefined} />
                                ))}
                            </div>

                            {/* center ring */}
                            <CenterRing />

                            {/* right cards */}
                            <div className="space-y-6">
                                {rightCards.map((c) => (
                                    <InfoCard key={c.title} title={c.title} desc={c.desc} img={undefined} />
                                ))}
                            </div>
                        </div>

                        {/* Mobile / Tablet layout */}
                        <div className="mt-10 lg:hidden">
                            {/* center ring first */}
                            <div className="flex justify-center">
                                <CenterRing />
                            </div>

                            {/* cards stacked */}
                            <div className="mt-10 space-y-5">
                                {[...[
                                    {
                                        title: "One Digital Business Page",
                                        desc: "All your business details, services, products, and contact options in one single digital page.",
                                    },
                                    {
                                        title: "Easy to Share Anywhere",
                                        desc: "Share your Digital Cart instantly using a link, QR code, or NFC card.",
                                    },
                                    {
                                        title: "Works on Any Device",
                                        desc: "Opens smoothly on mobile, tablet, and desktop without requiring any app.",
                                    },
                                ], ...rightCards].map((c) => (
                                    <InfoCard key={c.title} title={c.title} desc={c.desc} img={undefined} />
                                ))}
                            </div>
                        </div>
                    </div>
                </section>
            </m.section>

            {/* What You Can Do With Digital Cart? */}
            <m.section
                ref={featuresRef}
                initial="hidden"
                animate={featuresInView ? "visible" : "hidden"}
                variants={fadeIn}
                className=""
            >
                <section className="relative overflow-hidden bg-[#081328] md:py-[120px] py-[60px]">
                    {/* soft top glow */}
                    <div className="pointer-events-none absolute inset-0">
                        <div className="absolute -top-24 left-1/2 h-[360px] w-[720px] -translate-x-1/2 rounded-full bg-[#0B2A6A] opacity-[0.25] blur-[120px]" />
                        <div className="absolute -bottom-40 left-1/2 h-[420px] w-[820px] -translate-x-1/2 rounded-full bg-[#0A1D4A] opacity-[0.35] blur-[140px]" />
                    </div>

                    <div className="relative mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
                        {/* Header */}
                        <div className="text-center">
                            <p className="font-NeueMontreal text-[28px] sm:text-[40px] lg:text-[52px] font-extrabold leading-[1.1] text-white">
                                What You Can Do With{" "}
                                <span className="text-[#1F5DFF] font-NeueMontreal">Digital Cart?</span>
                            </p>

                            <p className="mx-auto mt-4 max-w-3xl font-Schibsted_Grotesk text-[13px] sm:text-[15px] lg:text-[16px] leading-[1.7] text-white/70">
                                Digital Cart is a simple digital page that represents your business online.
                                It brings all your business details, services, products, and contact options
                                into one easy-to-share link.
                            </p>
                        </div>

                        {/* Grid */}
                        <div className="mt-10 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
                            {features.map((f) => (
                                <div
                                    key={f.title}
                                    className="group relative rounded-[16px] border border-[#FFFFFF21] bg-white/5 p-6 shadow-[0_18px_60px_rgba(0,0,0,0.25)] backdrop-blur-md transition hover:bg-white/7"
                                >


                                    <div className="flex items-start justify-between gap-6">
                                        <div>
                                            <h3 className="font-Schibsted_Grotesk text-[18px] font-semibold text-white">
                                                {f.title}
                                            </h3>
                                            <p className="mt-2 font-Schibsted_Grotesk text-[13px] leading-[1.65] text-white/70">
                                                {f.desc}
                                            </p>
                                        </div>

                                        {/* Icon */}
                                        <div className="relative h-[72px] w-[72px] shrink-0">
                                            <Image
                                                src={f.img}
                                                alt={f.title}
                                                fill
                                                className="object-contain opacity-95"
                                            />
                                        </div>
                                    </div>

                                    {/* hover glow edge */}
                                    <div className="pointer-events-none absolute -inset-px rounded-[16px] opacity-0 blur-xl transition group-hover:opacity-40"
                                        style={{
                                            background:
                                                "radial-gradient(circle at 30% 20%, rgba(31,93,255,0.35), transparent 55%)",
                                        }}
                                    />
                                </div>
                            ))}
                        </div>
                    </div>
                </section>
            </m.section>

            {/* How Digital Cart Fits Into */}
            <m.section
                ref={pricingRef}
                initial="hidden"
                animate={pricingInView ? "visible" : "hidden"}
                variants={fadeIn}
                className=""
            >
                <section className="relative overflow-hidden bg-[#F6FAFF] md:py-[120px] py-[60px]">
                    {/* soft blue bottom wash */}
                    <div className="pointer-events-none absolute inset-0">
                        <div className="absolute -bottom-24 left-1/2 h-[420px] w-[900px] -translate-x-1/2 rounded-full bg-[#1F5DFF]/10 blur-[120px]" />
                    </div>

                    <div className="relative mx-auto max-w-6xl px-4 sm:px-6 lg:px-8 py-14 sm:py-16 lg:py-20">
                        <div className="grid grid-cols-1 items-center gap-12 lg:grid-cols-2">
                            {/* LEFT: phone */}
                            <div className="flex justify-center lg:justify-start">
                                <div className="relative w-[260px] sm:w-[320px] lg:w-[360px] aspect-[3/4]">
                                    {/* glow behind phone */}
                                    <div className="absolute -inset-10 rounded-full bg-[#1F5DFF]/15 blur-[60px]" />

                                    {/* desktop mockup */}
                                    <Image
                                        src={getImageUrl("/vilvabusiness/website/products/digitalcart/MobileMockup.svg")}
                                        alt="Digital Cart shown on a phone mockup"
                                        width={1078}
                                        height={1735}
                                        className=" relative z-10 h-auto w-full rotate-[-10deg] drop-shadow-[0_30px_70px_rgba(15,23,42,0.25)]"
                                        loading="lazy"
                                        decoding="async"
                                    />

                                </div>
                            </div>

                            {/* RIGHT: content */}
                            <div className="max-w-2xl">
                                <p className="font-NeueMontreal text-[36px] md:text-[48px] font-extrabold leading-[1.1] text-[#0B1535]">
                                    How <span className="text-[#1F5DFF] font-NeueMontreal">Digital Cart</span> Fits Into{" "} Real Life?
                                </p>

                                <p className="mt-4 font-Schibsted_Grotesk text-[16px] md:text-[18px] leading-[1.75] text-[#667085]">
                                    Digital Cart is a simple digital page that represents your business online.
                                    It brings all your business details, services, products, and contact
                                    options into one easy-to-share link.
                                </p>

                                {/* steps */}
                                <div className="mt-10 space-y-6">
                                    {steps.map((s) => (
                                        <div key={s.title} className="pb-6 border-b border-[#BFD2FF]">
                                            <p className="font-Schibsted_Grotesk text-[18px] md:text-[24px] font-semibold text-[#072162] leading-[100%]">
                                                {s.title}
                                            </p>
                                            <p className="mt-2 font-Schibsted_Grotesk text-[16px] leading-[140%] text-[#374577]">
                                                {s.desc}
                                            </p>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </m.section>

            {/* Simple, One-Time Pricing */}
            <m.section
                ref={pricingSectionRef}
                initial="hidden"
                animate={pricingSectionInView ? "visible" : "hidden"}
                variants={fadeIn}
                className=""
            >
                <section className="relative overflow-hidden md:py-[120px] py-[60px] sm:min-h-[100vh] min-h-[70vh] bg-cover bg-center bg-no-repeat">
                    {/* subtle grid background */}
                    <div className="pointer-events-none absolute inset-0 ">
                        {/* <Image
                            src={img6}
                            alt="image tag"
                            fill
                            priority
                            className="object-cover z-0"
                        /> */}

                        <Image
                            src={getImageUrl("/vilvabusiness/website/products/digitalcart/Pricing%20-%20Background.webp")}
                            alt=""
                            fill
                            className="object-cover z-0"
                            loading="lazy"
                            decoding="async"
                        />
                    </div>

                    <div className="relative mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
                        {/* Header */}
                        <div className="text-center">
                            <p className="font-NeueMontreal md:text-[48px] text-[36px] font-extrabold leading-[1.1] text-white">
                                Simple, <span className="text-[#1F5DFF] font-NeueMontreal">One-Time</span> Pricing
                            </p>

                            <p className="mx-auto mt-3 max-w-3xl font-Schibsted_Grotesk text-[16px] md:text-[18px] leading-[1.7] text-white/70">
                                Digital Cart is a simple digital page that represents your business online.
                                It brings all your business details, services, products, and contact options
                                into one easy-to-share link.
                            </p>
                        </div>

                        {/* Pricing Card */}
                        <div className="mt-10 flex justify-center">
                            <div className="relative w-full max-w-[360px] rounded-[14px] border border-white/15 bg-white/5 px-7 py-7 shadow-[0_0_12px_0_rgba(199, 199, 199, 0.16)] backdrop-blur-md">
                                {/* inner highlight */}
                                <div className="pointer-events-none absolute inset-0 rounded-[16px] ring-1 ring-white/10" />

                                <div className="text-center">
                                    <p className="font-Schibsted_Grotesk text-[28px] font-semibold text-white">
                                        DigitalCart
                                    </p>

                                    <div className="mt-2 flex items-end justify-center gap-2">
                                        <span className="font-Schibsted_Grotesk text-[36px] font-[600] text-[#1F5DFF]">
                                            ₹1999
                                        </span>
                                        <span className="pb-[6px] font-Schibsted_Grotesk text-[18px] text-[#FFFFFFCC]">
                                            /lifetime
                                        </span>
                                    </div>

                                    <p className="mt-6 font-Schibsted_Grotesk text-[13px] font-semibold text-[#FFFFFF]">
                                        What’s Included
                                    </p>
                                </div>

                                <ul className="mt-4 space-y-3">
                                    {included.map((item) => (
                                        <li key={item} className="flex items-start gap-[8px]">
                                            <SvgIcons.TickSvg />

                                            <span className="font-Schibsted_Grotesk text-[14px] leading-[1.6] text-[#FFFFFF]">
                                                {item}
                                            </span>
                                        </li>
                                    ))}
                                </ul>

                                <a
                                    href="#"
                                    className="mt-6 flex h-[44px] w-full items-center justify-center rounded-[10px] bg-[#1F5DFF] font-Schibsted_Grotesk text-[16px] font-semibold text-white shadow-[0_14px_30px_rgba(31,93,255,0.25)] hover:opacity-95 transition"
                                >
                                    Get Digital Cart
                                </a>

                                <p className="mt-[16px] text-center font-[500] font-Schibsted_Grotesk text-[14px] text-[#FFFFFF]">
                                    One-time setup. No monthly charges.
                                </p>
                            </div>
                        </div>
                    </div>
                </section>
            </m.section>

            {/* Digital Cart vs Traditional Visiting Cards */}
            <m.section
                ref={comparisonRef}
                initial="hidden"
                animate={comparisonInView ? "visible" : "hidden"}
                variants={fadeIn}
                className=""
            >
                <section className="relative overflow-hidden bg-[#F6FAFF] md:py-[120px] py-[60px] relative overflow-hidden bg-[#F6FAFF] relative sm:min-h-[100vh] min-h-[70vh] bg-cover bg-center bg-no-repeat text-white overflow-hidden">
                    {/* subtle grid background */}
                    <div className="pointer-events-none absolute inset-0 opacity-[0.55]">
                        <Image
                            src={getImageUrl("/vilvabusiness/website/products/digitalcart/BackgroundDigital%20Cart.webp")}
                            alt=""
                            fill
                            className="object-cover z-0"
                            loading="lazy"
                            decoding="async"
                        />
                    </div>

                    <div className="relative mx-auto max-w-6xl px-[18px]">
                        {/* Heading */}
                        <div className="text-center">
                            <p className="font-NeueMontreal md:text-[48px] text-[36px] font-extrabold leading-[1.15] text-[#0B1535]">
                                <span className="text-[#1F5DFF] font-NeueMontreal">Digital Cart</span> vs Traditional Visiting Cards
                            </p>

                            <p className="mt-3 font-Schibsted_Grotesk md:text-[18px] text-[16px] text-[#374577]">
                                See the difference for yourself
                            </p>
                        </div>

                        {/* Table */}
                        <div className="mt-10 flex justify-center">
                            <div className="w-full max-w-3xl overflow-hidden rounded-[12px] border border-[#7AA5FF] bg-white shadow-[0_0_24px_rgba(133,168,255,1)]">
                                {/* header */}
                                <div className="grid grid-cols-[1.4fr_0.8fr_0.8fr] bg-[#EEF4FF] px-6 py-4">
                                    <div />
                                    <div className="text-center font-Schibsted_Grotesk md:text-[20px] text-[18px] font-[700] text-[#06225E]">
                                        Digital Cart
                                    </div>
                                    <div className="text-center font-Schibsted_Grotesk md:text-[20px] text-[18px] font-[700] text-[#06225E]">
                                        Paper Cards
                                    </div>
                                </div>

                                {/* rows */}
                                <div>
                                    {rows.map((r, i) => (
                                        <div
                                            key={r.label}
                                            className={[
                                                "grid grid-cols-[1.4fr_0.8fr_0.8fr] items-center px-6 py-4 ",
                                                "border-t border-[#C7D7FF]",
                                                i % 2 === 1 ? "bg-[#F7FAFF]" : "bg-white",
                                            ].join(" ")}
                                        >
                                            <div className="font-Schibsted_Grotesk md:text-[20px] text-[18px] font-[500] text-[#0B1535]">
                                                {r.label}
                                            </div>

                                            <div className="flex justify-center">
                                                {r.digital ? (
                                                    <span className="inline-flex h-6 w-6 items-center justify-center rounded-full bg-[#1F5DFF]">
                                                        <Check className="h-4 w-4 text-white" strokeWidth={3} />
                                                    </span>
                                                ) : (
                                                    <span className="text-[#111827]">No</span>
                                                )}
                                            </div>

                                            <div className="text-center font-Schibsted_Grotesk text-[16px] text-[#111827]">
                                                {r.paper}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </m.section>

            {/* We Make for Your Team */}
            <m.section
                ref={teamRef}
                initial="hidden"
                animate={teamInView ? "visible" : "hidden"}
                variants={fadeIn}
                className="bg-[#01001E]"
            >
                <div className='bg-[#01001E]'>
                    <section className='px-3 py-[60px] md:container md:p-0 md:py-[120px] '>
                        <h4 className='text-center font-Schibsted_Grotesk text-[32px] font-extrabold leading-[120%] text-white md:text-[48px]'>
                            We Make for Your Team{' '}
                        </h4>
                        <p className='py-4  text-center font-Schibsted_Grotesk text-[16px] font-normal leading-[150%] text-white md:text-[18px]'>
                            Our team ensures timely results without compromising quality
                        </p>

                        <section className='flex items-center justify-center gap-3 '>
                            <TestiReviewCommonImages />
                            <div>
                                <a
                                    href='https://maps.app.goo.gl/wxZr7ckDhrWnVbx27'
                                    className='text-[#090D28]'
                                    target='_blank'
                                >
                                    {' '}
                                    <p className=' m-0 flex items-center gap-1 p-0 pb-[6px] text-center font-LatinkaRegular text-sm font-normal leading-[120%] text-white'>
                                        <Image className='w-6' src={getImageUrl("/vilvabusiness/website/common/homepage/google-img.webp")} alt='GoogleImg' width={50} height={50}  />{' '}
                                        Google Reviews
                                    </p>
                                </a>
                                <div className='flex items-center gap-2 text-white'>
                                    4.7
                                    <div className='flex items-center gap-2'>
                                        <SvgIcons.ReviewStar />
                                        <SvgIcons.ReviewStar />
                                        <SvgIcons.ReviewStar />
                                        <SvgIcons.ReviewStar />
                                        <SvgIcons.ReviewStar />
                                    </div>
                                </div>
                            </div>
                        </section>

                        <section className='pt-[20px] md:container md:pt-[30px]'>
                            <StatsSection />
                        </section>
                    </section>
                </div>
            </m.section>

            {/* FAQ Section */}
            <section id="faq" className="pb-[60px] md:pb-[120px] px-4 md:px-0 md:container">
                <FaqSection faqs={digitalCartFaqItems} initialShowAll />
            </section>
        </div >
    );
};

export default DigitalCart;